var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCv({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 9,
    viewBox: "0 0 17 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.16732 8.45829V2.12496H0.583984V0.541626H3.75065V8.45829H2.16732ZM16.4173 6.87496C16.4173 7.75371 15.7048 8.45829 14.834 8.45829H11.6673V6.87496H14.834V5.29163H13.2507V3.70829H14.834V2.12496H11.6673V0.541626H14.834C15.2539 0.541626 15.6566 0.708441 15.9536 1.00537C16.2505 1.30231 16.4173 1.70503 16.4173 2.12496V3.31246C16.4173 3.6274 16.2922 3.92945 16.0695 4.15215C15.8468 4.37485 15.5448 4.49996 15.2298 4.49996C15.5448 4.49996 15.8468 4.62507 16.0695 4.84777C16.2922 5.07047 16.4173 5.37251 16.4173 5.68746V6.87496ZM10.084 6.87496V8.45829H5.33398V5.29163C5.33398 4.41288 6.04648 3.70829 6.91732 3.70829H8.50065V2.12496H5.33398V0.541626H8.50065C8.92058 0.541626 9.3233 0.708441 9.62024 1.00537C9.91717 1.30231 10.084 1.70503 10.084 2.12496V3.70829C10.084 4.58704 9.37148 5.29163 8.50065 5.29163H6.91732V6.87496H10.084Z",
    fill: "#0D6EFD"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCv);
export default __webpack_public_path__ + "static/media/CV.2650543f.svg";
export { ForwardRef as ReactComponent };